import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GuidedTour, TourStep, GuidedTourService } from 'ngx-guided-tour';
import { User } from '../user/user.model';
import { UserAuthService } from '../user/user-auth.service';
import { AlertService } from '../alert/alert.service';
import { WaitingService } from '../../features/layout/waiting/waiting.service';

@Injectable({
    providedIn: 'root',
})
export class WvGuidedTourService {
    window: Window;
    constructor(
        private userAuth$: UserAuthService,
        private alert$: AlertService,
        private guidedTour$: GuidedTourService,
        private waiting$: WaitingService
    ) {
        this.window = <Window>window;
    }

    /**
     * Initialise et lance le tour guidé si l'utilisateur ne l'a jamais vu
     *
     * @param [forceTour=false] si = `true`, force le tuto
     */
    public async launchParkTour(forceTour: boolean = false) {
        const isMobile: boolean = this.window.innerWidth <= 900;

        const userInfo: User = await this.userAuth$.refreshUserInfos();
        if (!userInfo.wvGuidedTourParkComplete || forceTour === true) {
            const parkTourSteps: TourStep[] = [
                {
                    title: 'Bienvenue sur Wanview !',
                    content:
                        'Découvrons ensemble la page de votre parc de diffusion',
                },
                {
                    selector: '#screenList',
                    title: 'Liste des écrans',
                    content: 'Retrouvez ici la liste de vos écrans',
                    orientation: 'center',
                },
                {
                    selector: '#screenInfo',
                    title: 'Ecran',
                    content: "Ici, la représentation d'un écran",
                    orientation: isMobile ? 'center' : 'right',
                },
                {
                    selector: '#screenHeader',
                    title: 'Ecran',
                    content:
                        "Avec au dessus, <br/>les informations concernant l'écran",
                    orientation: isMobile ? 'bottom' : 'right',
                },
                {
                    selector: '#campaignList',
                    title: 'Campagnes',
                    content: 'Et en dessous, <br/>vos campagnes sur cet écran',
                    orientation: isMobile ? 'top' : 'right',
                },
                {
                    selector: '#diffusionItem',
                    title: 'Diffusions',
                    content: 'Chaque campagne possède au moins une diffusion',
                    orientation: isMobile ? 'top' : 'right',
                },
                {
                    selector: '#thumbnailItem',
                    title: 'Diffusion',
                    content:
                        "Ici sera affiché votre spot lorsque vous l'aurez défini <br/> Ce sera ici pour y mettre un spot",
                    orientation: 'top',
                },
                {
                    selector: '#infoDiff',
                    title: 'Diffusion',
                    content:
                        'Et ici sont affichées les informations de cette diffusion',
                    orientation: 'top',
                },
                {
                    selector: '#addNewdDiffWncmBtn',
                    title: 'Ajout de diffusions',
                    content:
                        'Enfin,<br/> vous pouvez ajouter des diffusions supplémentaires ici qui iront remplacer la diffusion par défaut selon les paramètres que vous lui donnerez',
                    orientation: isMobile ? 'top' : 'right',
                },
                {
                    title: 'Terminé',
                    content:
                        'Voici pour la découverte de votre espace !<br/> Bonne continuation !',
                },
            ];

            const tourId = 'ParkTour';
            const parkTour: GuidedTour = {
                tourId: tourId,
                steps: parkTourSteps,
                skipCallback: () => {
                    this.onTourComplete(tourId);
                },
                completeCallback: () => {
                    this.onTourComplete(tourId);
                },
            };

            this.guidedTour$.startTour(parkTour);
        }
    }


    public async launchGeneratorTour(forceTour: boolean = false) {
        const isMobile: boolean = this.window.innerWidth <= 900;

        const userInfo: User = await this.userAuth$.refreshUserInfos();
        if (!userInfo.wvGuidedTourParkComplete || forceTour === true) {
            const parkTourSteps: TourStep[] = [
                {
                    title: 'Bienvenue sur le générateur de spot !',
                    content:
                        'Découvrons le ensemble!',
                },
                {
                    selector: '#leftShutter',
                    title: 'Liste des éléments modifiables',
                    content: 'Retrouvez ici la liste de tous les éléments que vous allez pouvoir modifier, que ce soit du texte ou une image',
                    orientation: 'center',
                },
                {
                    selector: '#produit',
                    title: 'Sélection d\'un produit',
                    content: "Ajouter un produit au spot en sélectionnant une image lié à un texte",
                    orientation: isMobile ? 'center' : 'right',
                },
                {
                    selector: '#produit',
                    title: 'Sélection d\'un produit',
                    content: "Ajouter un produit au spot en sélectionnant une image lié à un texte",
                    orientation: isMobile ? 'center' : 'right',
                },
                {
                    selector: '#item',
                    title: 'Sélection d\'une image',
                    content:
                        "Ajouter une image a votre spot",
                    orientation: isMobile ? 'bottom' : 'right',
                },
                {
                    selector: '#campaignList',
                    title: 'Campagnes',
                    content: 'Et en dessous, <br/>vos campagnes sur cet écran',
                    orientation: isMobile ? 'top' : 'right',
                },
                {
                    selector: '#diffusionItem',
                    title: 'Diffusions',
                    content: 'Chaque campagne possède au moins une diffusion',
                    orientation: isMobile ? 'top' : 'right',
                },
                {
                    selector: '#thumbnailItem',
                    title: 'Diffusion',
                    content:
                        "Ici sera affiché votre spot lorsque vous l'aurez défini <br/> Ce sera ici pour y mettre un spot",
                    orientation: 'top',
                },
                {
                    selector: '#infoDiff',
                    title: 'Diffusion',
                    content:
                        'Et ici sont affichées les informations de cette diffusion',
                    orientation: 'top',
                },
                {
                    selector: '#addNewdDiffWncmBtn',
                    title: 'Ajout de diffusions',
                    content:
                        'Enfin,<br/> vous pouvez ajouter des diffusions supplémentaires ici qui iront remplacer la diffusion par défaut selon les paramètres que vous lui donnerez',
                    orientation: isMobile ? 'top' : 'right',
                },
                {
                    title: 'Terminé',
                    content:
                        'Voici pour la découverte de votre espace !<br/> Bonne continuation !',
                },
            ];

            const tourId = 'ParkTour';
            const parkTour: GuidedTour = {
                tourId: tourId,
                steps: parkTourSteps,
                skipCallback: () => {
                    this.onTourComplete(tourId);
                },
                completeCallback: () => {
                    this.onTourComplete(tourId);
                },
            };

            this.guidedTour$.startTour(parkTour);
        }
    }


    /**
     * Fonction appelée quand un tour guidé est terminé ou passé
     */
    private onTourComplete(tourId: string) {
        const waitingId: string = this.waiting$.start();
        this.userAuth$.updateGuidedTourInfo(tourId).subscribe({
            next: () => {
                this.waiting$.end(waitingId);
                this.userAuth$.refreshUserInfos(true);
            },
            error: (err: HttpErrorResponse) => {
                this.waiting$.end(waitingId);
                console.error(err);

                this.alert$.show({
                    message: 'Une erreur est survenue lors de la fin du tour',
                    duration: 1500,
                });
            },
        });
    }
}
